export default {"src":"/_next/static/media/sample-reports.422b0dea.svg","height":30,"width":26,"blurWidth":0,"blurHeight":0};